export const DEFAULT_POINT_SIZE = 8;
export const DEFAULT_HOOP_SCALE = 1;
